import type { PANEL_OPERATION_METADATA } from '@exylon/generated-contract-kernel/types';
import { TPV_PROBE_TIMEOUT_MS } from './constants';

/**
 * The TPV without a connection (docs/decisions/2026-10-28-tpv-sin-conexion.md): its operations. The TPV's operation
 * names include them (`../contract-port.ts`), which puts them in the Panel's screen operations and the private
 * client's allowed set.
 */
export const TPV_OFFLINE_OPERATION_NAMES = Object.freeze({
  /** Every TPV's probe while its session is valid: the server's instant, read in the database. */
  readProbe: 'service.probe.read.v1',
  /** The probe without a session: the server's instant, public. */
  readClock: 'service.clock.read.v1',
  /** One table's journal, uploaded on the return (the sync engine). */
  recordOfflineSegment: 'service.offline-segment.record.v1',
} as const satisfies Record<string, keyof typeof PANEL_OPERATION_METADATA>);

/** The two probes answer within 6 s or count as unreachable (the client's default is 15 s). */
export const TPV_PROBE_OPERATION_TIMEOUTS_MS: Readonly<Record<string, number>> = Object.freeze({
  [TPV_OFFLINE_OPERATION_NAMES.readProbe]: TPV_PROBE_TIMEOUT_MS,
  [TPV_OFFLINE_OPERATION_NAMES.readClock]: TPV_PROBE_TIMEOUT_MS,
});
